/* eslint-disable react/prop-types */
import React from 'react';
import CustomModal from '../../common/modal/modal';

const PatientFilesPreviewModal = ({ show, previewUrl, onClose }) => (
    <CustomModal
        size="xl"
        show={show}
        setShow={(open) => {
            if (!open) onClose();
        }}
        isHeaderHide={true}
        autoClose={true}
    >
        <div className="patient-files__preview-wrap">
            <div className="patient-files__preview-head">
                <button
                    type="button"
                    className="patient-files__modal-close"
                    onClick={onClose}
                    aria-label="Close preview"
                >
                    ×
                </button>
            </div>
            {previewUrl ? (
                <iframe
                    title="Document preview"
                    className="patient-files__preview-frame"
                    src={previewUrl}
                />
            ) : null}
        </div>
    </CustomModal>
);

export default PatientFilesPreviewModal;
